import { Box } from "@mui/material";

import { useEffect, useState } from "react";

//import PolicyUpdateForm from "./form";
import { AccountsandFinanceurl } from "../../../../config";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AssetTypesColumns } from "../../../../data/DynamicTable/Collumns";
import {allAssetTypes} from "../../../../data/Columns/Queries/FixedAssetManagement/fixedAssetsmanagement";
import AssetTypeForm from "./form";

const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Asset Types",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "id",
     inputObjectName: "activateDeactivateFixedAssetType",
     required: "id"
  },

  showStatus: true,
};
function AssetsTypes() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Assets Types"
          subtitle="View all assets types, add and edit"
          columns={AssetTypesColumns}
          FormComponent={AssetTypeForm}
          actions={actions}
          query={allAssetTypes}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default AssetsTypes;
